import { render, staticRenderFns } from "./AddSubEvent.vue?vue&type=template&id=fa60908a&scoped=true"
import script from "./AddSubEvent.vue?vue&type=script&lang=js"
export * from "./AddSubEvent.vue?vue&type=script&lang=js"
import style0 from "./AddSubEvent.vue?vue&type=style&index=0&id=fa60908a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa60908a",
  null
  
)

export default component.exports